import { PropsWithChildren } from 'react'

import { createStyles } from 'antd-style'

const useStyles = createStyles(() => ({
  container: {
    position: 'relative',
    width: '22px',
    height: '22px',
    textAlign: 'center'
  },
  longSquare: {
    position: 'absolute',
    width: '100%',
    top: '0px',
    height: '2px',
    background: '#87909B'
  },
  square: {
    position: 'absolute',
    width: '18px',
    marginInline: '2px',
    top: '2px',
    height: '12px',
    background: '#87909B'
  },
  triangular: {
    position: 'absolute',
    top: '13px',
    width: '18px',
    marginInline: '2px',
    background: '#87909B',
    height: '6px',
    borderInline: '8px solid transparent',
    borderBlock: '4px solid transparent',
    borderBlockEndColor: 'white'
  },
  children: {
    position: 'absolute',
    width: '22px',
    top: '2px',
    lineHeight: '14px',
    textAlign: 'center',
    color: 'white',
    fontWeight: 700
  }
}))

export const RankingIndexTag = ({ children }: PropsWithChildren) => {
  const { styles } = useStyles()
  return (
    <div className={styles.container}>
      <div className={styles.longSquare} />
      <div className={styles.square} />
      <div className={styles.triangular} />
      <div className={styles.children}>{children}</div>
    </div>
  )
}
